"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var invariant_1 = __importDefault(require("invariant"));
var context_1 = require("./context");
var common_1 = require("./common");
exports.useApi = function (config, opt) {
    var rawConfig = config;
    if (typeof config === 'string') {
        config = {
            url: config
        };
    }
    invariant_1.default(exports.verifyConfig(config), "API config \"" + rawConfig + "\" is invalid.");
    var context = react_1.useContext(context_1.ApiContext);
    var _a = context.settings, cache = _a.cache, debug = _a.debug, shouldUseApiCache = _a.shouldUseApiCache, isSSR = context.isSSR, _b = context.collection, ssrConfigs = _b.ssrConfigs, cacheKeys = _b.cacheKeys;
    var cacheKey = JSON.stringify(config);
    var options = react_1.useMemo(function () { return exports.handleUseApiOptions(opt, cacheKey); }, [
        opt,
        cacheKey
    ]);
    var ref = react_1.useRef({
        isRequesting: false,
        isFeeding: false,
        refreshFlag: 1
    });
    var refData = ref.current;
    var cacheData = cache.get(cacheKey);
    var defaultState = __assign({}, common_1.initState);
    if (cacheData && (isSSR || !!shouldUseApiCache(config, cacheKey))) {
        var response = cacheData.response, error = cacheData.error;
        var action = {
            type: common_1.ACTIONS.REQUEST_END,
            response: response,
            error: error,
            options: options
        };
        debug && console.log('[ReactUseApi][Feed]', cacheKey);
        if (!isSSR) {
            action.fromCache = true;
            refData.isFeeding = true;
        }
        defaultState = exports.reducer(defaultState, action);
    }
    else if (isSSR) {
        if (!cacheKeys.has(cacheKey)) {
            cacheKeys.add(cacheKey);
            debug && console.log('[ReactUseApi][Collect]', cacheKey);
        }
        ssrConfigs.push({
            config: config,
            cacheKey: cacheKey
        });
    }
    var _c = react_1.useReducer(exports.reducer, defaultState), state = _c[0], dispatch = _c[1];
    var request = react_1.useCallback(function (cfg, keepState) {
        if (cfg === void 0) { cfg = config; }
        if (keepState === void 0) { keepState = false; }
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // update state's cachekey for saving the prevState when requesting (refreshing)
                // it's good to set true for pagination
                if (keepState) {
                    state.$cacheKey = cacheKey;
                }
                refData.isRequesting = true;
                return [2 /*return*/, exports.fetchApi(context, cfg, options, dispatch)];
            });
        });
    }, [context, cacheKey, options, dispatch, state, refData]);
    var shouldRequest = options.shouldRequest, watch = options.watch;
    // for each re-rendering
    if (!refData.isRequesting &&
        common_1.isFunction(shouldRequest) &&
        shouldRequest() === true) {
        refData.refreshFlag = Date.now();
    }
    var loading = state.loading, data = state.data;
    if (!loading && refData.isRequesting) {
        refData.isRequesting = false;
    }
    react_1.useEffect(function () {
        // SSR will never invoke request() due to the following cases:
        // 1. There is a cacheData for the cacheKey
        // 2. Feeding the data come from the cache
        // For non-SSR, cacheData will be undefined if cacheKey has been changed
        if (!isSSR && !cacheData && !refData.isFeeding) {
            request();
        }
        if (refData.isFeeding) {
            refData.isFeeding = false;
        }
    }, [cacheKey, refData.refreshFlag].concat((Array.isArray(watch) ? watch : [])));
    return [data, state, request];
};
exports.reducer = function (state, action) {
    var type = action.type, options = action.options;
    var cacheKey = options.$cacheKey;
    var basicState = {
        $cacheKey: cacheKey
    };
    switch (type) {
        case common_1.ACTIONS.REQUEST_START: {
            return __assign({}, (cacheKey !== state.$cacheKey ? common_1.initState : state), { loading: true, error: undefined, fromCache: false }, basicState);
        }
        case common_1.ACTIONS.REQUEST_END: {
            var response = action.response, error = action.error, fromCache = action.fromCache;
            var pre = state.prevState, prevState = __rest(state, ["prevState"]);
            var prevData = prevState.data;
            var dependencies = options.dependencies;
            var newState = __assign({}, prevState, { prevData: prevData,
                prevState: prevState, loading: false, response: response,
                dependencies: dependencies,
                error: error, fromCache: !!fromCache }, basicState);
            newState.data = error ? undefined : common_1.getResponseData(options, newState);
            return newState;
        }
        default:
            return state;
    }
};
exports.fetchApi = function (context, config, options, dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var cache, cacheKey, _a, response, error, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                cache = context.settings.cache;
                cacheKey = options.$cacheKey;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 5, , 6]);
                _a = cache.get(cacheKey) || {}, response = _a.response, error = _a.error;
                if (!(response || error)) return [3 /*break*/, 2];
                cache.del(cacheKey);
                return [3 /*break*/, 4];
            case 2:
                dispatch({ type: common_1.ACTIONS.REQUEST_START, options: options });
                return [4 /*yield*/, common_1.axiosAll(context, config)];
            case 3:
                response = _b.sent();
                _b.label = 4;
            case 4:
                dispatch({ type: common_1.ACTIONS.REQUEST_END, response: response, error: error, options: options });
                return [3 /*break*/, 6];
            case 5:
                error_1 = _b.sent();
                dispatch({
                    type: common_1.ACTIONS.REQUEST_END,
                    error: error_1,
                    options: options
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
exports.handleUseApiOptions = function (opt, cacheKey) {
    var options = common_1.isObject(opt)
        ? __assign({}, opt)
        : {
            watch: Array.isArray(opt) ? opt : [],
            handleData: common_1.isFunction(opt) ? opt : undefined
        };
    options.$cacheKey = cacheKey;
    return options;
};
exports.verifyConfig = function (config) {
    return common_1.isObject(config)
        ? !!config.url
        : Array.isArray(config)
            ? config.every(function (each) { return !!each.url; })
            : false;
};
exports.default = exports.useApi;
//# sourceMappingURL=useApi.js.map